import { LatLngAlt } from "../../../types.js";

const stream: LatLngAlt[] = [
  [-10.756134, 165.852485, 166.6],
  [-10.756122, 165.852635, 167],
  [-10.756111, 165.852807, 167.6],
  [-10.756137, 165.852957, 168.6],
  [-10.756164, 165.853118, 169],
  [-10.756184, 165.853279, 168.8],
  [-10.756205, 165.85344, 169.8],
  [-10.756211, 165.853611, 171.2],
  [-10.756197, 165.853783, 172.6],
  [-10.756276, 165.853901, 174.2],
  [-10.756401, 165.853997, 175.6],
  [-10.756443, 165.854126, 177.2],
  [-10.756384, 165.854266, 178.6],
  [-10.756303, 165.854394, 179.6],
  [-10.756224, 165.854512, 180.4],
  [-10.756256, 165.854652, 181.4],
  [-10.756394, 165.854663, 182.4],
  [-10.756523, 165.854588, 183],
  [-10.756665, 165.854545, 183.6],
  [-10.756803, 165.854598, 184.2],
  [-10.756866, 165.854738, 184.8],
  [-10.756868, 165.854888, 185.6],
  [-10.756863, 165.855049, 186.4],
  [-10.756862, 165.85521, 186.8],
  [-10.75688, 165.855371, 187.4],
  [-10.757015, 165.855446, 188],
  [-10.757164, 165.855392, 188.6],
  [-10.757227, 165.855242, 188.2],
  [-10.757263, 165.855081, 188.2],
  [-10.757315, 165.85492, 189.2],
  [-10.757355, 165.854759, 190.2],
  [-10.757371, 165.854588, 191.4],
  [-10.757424, 165.854448, 192.4],
  [-10.757571, 165.854394, 193],
  [-10.757692, 165.85448, 193.6],
  [-10.757738, 165.854652, 194.6],
  [-10.757762, 165.854802, 195.6],
  [-10.75779, 165.854952, 196.6],
  [-10.757817, 165.855124, 197.6],
  [-10.757815, 165.855274, 198.4],
  [-10.757832, 165.855424, 199.4],
  [-10.757943, 165.855532, 200.6],
  [-10.758092, 165.855564, 201.4],
  [-10.75823, 165.8555, 202.2],
  [-10.758312, 165.855371, 202.4],
  [-10.758332, 165.85521, 203],
  [-10.758308, 165.85506, 203.8],
  [-10.758297, 165.854888, 204.8],
  [-10.75832, 165.854738, 205.6],
  [-10.758358, 165.854588, 206.4],
  [-10.758416, 165.854437, 207.2],
  [-10.758501, 165.854298, 208],
  [-10.758606, 165.85418, 208.6],
  [-10.758741, 165.854105, 209.6],
  [-10.758897, 165.854105, 210.8],
  [-10.759042, 165.854148, 212.2],
  [-10.759179, 165.854223, 213.4],
  [-10.759284, 165.85433, 214.4],
  [-10.759326, 165.85448, 214.8],
  [-10.759358, 165.85463, 215.2],
  [-10.759441, 165.85477, 215.6],
  [-10.759539, 165.854909, 216.2],
  [-10.759581, 165.85506, 216.4],
  [-10.759554, 165.855231, 216.4],
  [-10.759557, 165.855414, 216.6],
  [-10.759616, 165.855564, 217],
  [-10.759755, 165.855671, 217.2],
  [-10.759924, 165.855682, 217.2],
  [-10.76003, 165.855553, 217.6],
  [-10.760088, 165.855381, 217.8],
  [-10.760158, 165.85521, 218],
  [-10.760274, 165.85506, 218],
  [-10.76041, 165.854952, 218.2],
  [-10.760546, 165.854813, 218.4],
  [-10.760666, 165.854684, 219],
  [-10.760787, 165.854545, 219.6],
  [-10.760945, 165.854448, 219.8],
  [-10.761128, 165.85448, 219.2],
  [-10.761308, 165.854523, 219],
  [-10.761493, 165.854555, 219],
  [-10.761678, 165.854523, 218.8],
  [-10.761851, 165.854448, 218.8],
  [-10.762008, 165.854545, 219.2],
  [-10.762087, 165.854727, 219.6],
  [-10.762059, 165.854909, 220],
  [-10.761932, 165.855049, 220.4],
  [-10.761781, 165.855156, 220.8],
  [-10.761627, 165.855263, 221],
  [-10.761477, 165.855371, 221.2],
  [-10.761347, 165.855446, 221],
  [-10.761234, 165.855521, 221],
  [-10.761139, 165.855564, 220.8],
  [-10.761063, 165.855607, 220.8],
  [-10.761006, 165.855639, 220.8],
  [-10.760968, 165.855671, 220.8],
  [-10.760956, 165.855671, 220.8],
  [-10.7609, 165.855714, 220.8],
  [-10.760829, 165.855768, 220.8],
  [-10.760746, 165.855821, 220.8],
  [-10.760648, 165.855886, 220.8],
  [-10.760541, 165.855961, 220.8],
  [-10.760428, 165.856036, 220.8],
  [-10.760313, 165.856143, 220.8],
  [-10.760213, 165.856251, 220.8],
  [-10.760161, 165.856401, 220.8],
  [-10.760172, 165.856572, 220.8],
  [-10.760179, 165.856744, 221.2],
  [-10.760161, 165.856905, 221.8],
  [-10.760117, 165.857077, 222.4],
  [-10.760004, 165.857195, 222.8],
  [-10.759856, 165.857291, 223],
  [-10.759692, 165.857334, 223],
  [-10.759519, 165.857366, 223],
  [-10.759342, 165.857366, 223.4],
  [-10.759172, 165.857323, 223.2],
  [-10.759018, 165.857216, 221.6],
  [-10.758857, 165.85712, 220],
  [-10.75868, 165.857162, 220.8],
  [-10.758651, 165.857345, 220.4],
  [-10.758732, 165.857517, 218.4],
  [-10.758831, 165.857699, 216.4],
  [-10.758928, 165.857881, 214.4],
  [-10.758918, 165.858064, 213.8],
  [-10.758741, 165.858171, 212.4],
  [-10.758535, 165.858225, 211],
  [-10.758354, 165.85831, 209.4],
  [-10.758214, 165.858482, 207.6],
  [-10.758057, 165.858632, 205.8],
  [-10.757852, 165.858675, 203.8],
  [-10.757644, 165.8586, 202.2],
  [-10.757453, 165.858493, 200.6],
  [-10.757266, 165.858386, 199.4],
  [-10.757081, 165.858268, 198.2],
  [-10.756889, 165.85816, 197.4],
  [-10.756687, 165.858085, 198.2],
  [-10.756482, 165.858085, 198.8],
  [-10.756356, 165.858235, 198.2],
  [-10.756354, 165.858428, 198.2],
  [-10.756364, 165.858632, 198.2],
  [-10.756367, 165.858847, 198.2],
  [-10.756366, 165.85904, 198.4],
  [-10.756272, 165.859201, 198.4],
  [-10.756077, 165.859201, 198.6],
  [-10.755883, 165.859201, 198.6],
  [-10.75569, 165.859179, 198.6],
  [-10.755509, 165.859137, 197.8],
  [-10.755387, 165.858965, 196.6],
  [-10.755355, 165.858783, 195],
  [-10.755419, 165.858589, 193.6],
  [-10.75558, 165.858461, 193.6],
  [-10.755696, 165.85831, 193.4],
  [-10.755596, 165.858139, 192.4],
  [-10.755417, 165.858064, 190.8],
  [-10.755256, 165.858192, 189.2],
  [-10.755081, 165.85831, 187.6],
  [-10.75488, 165.858375, 185.8],
  [-10.75467, 165.858375, 184.2],
  [-10.75446, 165.858353, 182.8],
  [-10.754314, 165.858514, 181],
  [-10.754214, 165.858707, 179.2],
  [-10.754043, 165.858825, 177.2],
  [-10.753831, 165.858804, 175.6],
  [-10.753796, 165.8586, 173.8],
  [-10.753838, 165.858375, 172.6],
  [-10.753688, 165.858235, 171],
  [-10.753474, 165.858192, 169.6],
  [-10.753347, 165.85801, 167.6],
  [-10.753272, 165.857806, 165.8],
  [-10.753161, 165.857613, 165.2],
  [-10.752959, 165.857549, 163.4],
  [-10.752737, 165.857549, 161.2],
  [-10.752516, 165.857559, 159.6],
  [-10.752297, 165.857613, 158],
  [-10.752077, 165.857592, 156.4],
  [-10.751862, 165.857538, 155],
  [-10.751649, 165.857474, 154.4],
  [-10.75145, 165.857399, 153.6],
  [-10.751271, 165.857259, 152.6],
];

export default stream;
